import React from 'react';
import { ADMIN_ACCESS } from './PermissionsRoutes';

const Forbidden = React.lazy(() => import('pages/common/Forbidden'))
const NotFound = React.lazy(() => import('pages/common/404'))

const ManagementCompany = React.lazy(() => import('pages/management/company-info/ManagementCompany'))
const ManagementCompanyViewEdit = React.lazy(() => import('pages/management/company-info/ManagementCompanyViewEdit'))

const Attendance = React.lazy(() => import('pages/basic-info/Attendance'))
const OGDP = React.lazy(() => import('pages/basic-info/OGDP'))
const Insurance = React.lazy(() => import('pages/basic-info/Insurance'))
const BasicInfoInsuranceAdd = React.lazy(() => import('pages/management/basic-info/BasicInfoInsuranceAdd'))
const Tax = React.lazy(() => import('pages/basic-info/Tax'))
const SimpleTax = React.lazy(() => import('pages/basic-info/SimpleTax'))
const SalaryItem = React.lazy(() => import('pages/basic-info/SalaryItem'))
const Holiday = React.lazy(() => import('pages/basic-info/Holiday'))

const Employee = React.lazy(() => import('pages/hrm/Employee'))
const EmployeeAdd = React.lazy(() => import('pages/hrm/EmployeeAdd'))
const EmployeeDetail = React.lazy(() => import('pages/hrm/EmployeeDetail'))

const EmployeeList = React.lazy(() => import('pages/hrm/EmployeeList'))


const PF = '/basic-info'
const RoutesBasicInfo = [
    { path: `${PF}`, exact: true, name: '기초정보관리' },
    { path: `${PF}/company-info`, exact: true, name: '회사정보', element: <ManagementCompany />, ...ADMIN_ACCESS },
    { path: `${PF}/company-info/detail/:corp_no`, exact: true, name: '상세', element: <ManagementCompanyViewEdit />, ...ADMIN_ACCESS },
    { path: `${PF}/company-info/rewrite/:corp_no`, exact: true, name: '수정', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/company-info/delete`, exact: true, name: '삭제', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/company-info/department`, exact: true, name: '부서·직급 정보', element: <OGDP />, ...ADMIN_ACCESS },
    { path: `${PF}/company-info/department/detail`, exact: true, name: '상세', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/company-info/department/write`, exact: true, name: '작성', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/company-info/department/rewrite`, exact: true, name: '수정', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/company-info/department/delete`, exact: true, name: '삭제', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/company-info/approval-line`, exact: true, name: '결재선', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/company-info/approval-line/write`, exact: true, name: '작성', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/company-info/approval-line/rewrite`, exact: true, name: '수정', element: <NotFound />, ...ADMIN_ACCESS },

    { path: `${PF}/hrm`, exact: true, name: '인사관리' },
    { path: `${PF}/hrm/employee`, exact: true, name: '사원정보', element: <Employee />, ...ADMIN_ACCESS },
    { path: `${PF}/hrm/employee/detail/:empl_no`, exact: true, name: '상세', element: <EmployeeDetail />, ...ADMIN_ACCESS },
    { path: `${PF}/hrm/employee/write`, exact: true, name: '작성', element: <EmployeeAdd />, ...ADMIN_ACCESS },
    { path: `${PF}/hrm/employee/rewrite/:empl_no`, exact: true, name: '수정', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/hrm/employee/delete/:empl_no`, exact: true, name: '삭제', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/hrm/employee/list`, exact: true, name: '직원명부 조회', element: <EmployeeList />, ...ADMIN_ACCESS },
    { path: `${PF}/hrm/employee/retired-list`, exact: true, name: '퇴직자명부 조회', element: <EmployeeList type='retired' /> },

    { path: `${PF}/attendance`, exact: true, name: '근태정보' },
    { path: `${PF}/attendance/work-time`, exact: true, name: '기본근로시간', element: <Attendance />, ...ADMIN_ACCESS },
    { path: `${PF}/attendance/work-time/rewrite`, exact: true, name: '수정', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/holiday`, exact: true, name: '휴일정보', element: <Holiday />, ...ADMIN_ACCESS },
    { path: `${PF}/holiday/write`, exact: true, name: '작성', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/holiday/rewrite`, exact: true, name: '수정', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/holiday/delete`, exact: true, name: '삭제', element: <NotFound />, ...ADMIN_ACCESS },

    { path: `${PF}/salary`, exact: true, name: '급여항목관리' },
    { path: `${PF}/salary/4-insurance`, exact: true, name: '4대보험요율', element: <Insurance />, ...ADMIN_ACCESS },
    { path: `${PF}/salary/4-insurance/write`, exact: true, name: '4대보험요율 등록', element: <BasicInfoInsuranceAdd />, ...ADMIN_ACCESS },
    { path: `${PF}/salary/tax`, exact: true, name: '소득세율', element: <Tax />, ...ADMIN_ACCESS },
    { path: `${PF}/salary/item`, exact: true, name: '급여항목', element: <SalaryItem />, ...ADMIN_ACCESS },
    { path: `${PF}/salary/item/write`, exact: true, name: '작성', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/salary/item/rewrite`, exact: true, name: '수정', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/salary/item/delete`, exact: true, name: '삭제', element: <NotFound />, ...ADMIN_ACCESS },
    { path: `${PF}/salary/simple-tax`, exact: true, name: '간이세액표', element: <SimpleTax />, ...ADMIN_ACCESS },

]

export default RoutesBasicInfo;
